export default function colorAlpha(p, aColor, alpha) {
  var c = p.color(aColor);
  return p.color(
    'rgba(' + [p.red(c), p.green(c), p.blue(c), alpha].join(',') + ')',
  );
}



// WEBPACK FOOTER //
// ./src/sketches/color-alpha.js